// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__159BO","buttons":"Footer_buttons__19T_0"};